import { render, staticRenderFns } from "./GenericIvmApi.vue?vue&type=template&id=b634bc1a&"
import script from "./GenericIvmApi.vue?vue&type=script&lang=ts&"
export * from "./GenericIvmApi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports